import { Button, Divider, Image, Modal } from "antd";
import React, { useState } from "react";
import { IoMdImages } from "react-icons/io";
import venues_demo_image from "../../Images/venues/venues_demo_image.jpg";

export default function VendorImages({ VenuesDetails }) {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const showModal = () => {
    setIsModalOpen(true);
  };
  const handleOk = () => {
    setIsModalOpen(false);
  };
  const handleCancel = () => {
    setIsModalOpen(false);
  };
  return (
    <>
      <Button
        onClick={showModal}
        icon={<IoMdImages />}
        style={{
          borderRadius: 0,
          height: 40,
          position: "absolute",
          bottom: 20,
          right: 20,
          zIndex: 1000,
        }}
      >
        View Photos {VenuesDetails?.images?.length}
      </Button>
      <Modal
        title=""
        closable={{ "aria-label": "Custom Close Button" }}
        open={isModalOpen}
        onCancel={handleCancel}
        footer={[]}
        centered
        width={1300}
      >
        <h4>{VenuesDetails?.name} Images</h4>
        <Divider />
        <div className="row">
          {VenuesDetails?.images?.map((val, index) => (
            <div className="col-6" style={{ marginBottom: 25 }} key={index}>
              <Image
                className="w-100 h-100"
                src={val?.image || venues_demo_image}
                alt={VenuesDetails?.name}
                fallback={venues_demo_image}
              />
            </div>
          ))}
        </div>
      </Modal>
    </>
  );
}
